import { jsx as _jsx } from "react/jsx-runtime";
import { Label } from "semantic-ui-react";
import hi_model from "@iscr/models/hi/hi_model";
import CopyField from "@iscr/xAppLib/UIelems/CopyField";
export function IhiNumber({ value, plain }) {
    const formatted = hi_model.format_ihi(value);
    if (!formatted) {
        return null;
    }
    if (plain) {
        return formatted;
    }
    return _jsx(CopyField, { val: value, label: formatted, inline: true });
}
export function IhiDuplicateStatus({ row, }) {
    var _a, _b, _c, _d;
    if ((_b = (_a = row === null || row === void 0 ? void 0 : row.ihi_demo_info) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.is_primary) {
        return _jsx(Label, { content: "Primary", icon: "star", color: "olive", basic: true });
    }
    if ((_d = (_c = row.ihi_demo_info) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.duplicate_of) {
        return _jsx(Label, { content: "Duplicate", icon: "users", color: "brown", basic: true });
    }
    return null;
}
